/* eslint-disable react-hooks/set-state-in-effect -- pre-existing in this legacy file; the dark-mode sweep only themes its colour literals */
/* eslint-disable check-file/filename-blocklist -- pre-existing .jsx; this change only swaps an icon import, converting to .tsx is a separate migration */
import { Flex, Icon, Spinner } from '@chakra-ui/react';
import { useQueryParams } from '@/hooks';
import { AccepetedIntro, DeclinedIntro, IntroTextResult } from './introResults';
import { getMessage } from './constant';
import {
  useAcceptPublicIntroMutation,
  useDeclinePublicIntroMutation,
  useGetPublicIntroByGuidQuery,
} from '@/store/query/public-intros';
import { useEffect, useState } from 'react';
import { PublicDeny } from '@/assets/icons/intros';
import { CheckCircle } from '@kula-ai/icons-core';

export const PublicConsent = () => {
  const params = useQueryParams();
  const introId = params.get('introId');
  const isAccept = Boolean(params.get('accept'));
  const isDeny = Boolean(params.get('deny'));
  const [introState, setIntroState] = useState(null);
  const [loading, setLoading] = useState(true);
  const [declinePublicIntro] = useDeclinePublicIntroMutation();
  const [acceptPublicIntro] = useAcceptPublicIntroMutation();
  const {
    isFetching,
    data: publicIntro,
    error,
  } = useGetPublicIntroByGuidQuery(
    {
      introId,
    },
    { skip: !introId?.length }
  );

  const onAccept = async () => {
    const res = await acceptPublicIntro({ introId: introId });
    if (res?.error?.length) {
      setIntroState(res?.error[0]);
      setLoading(false);
      return;
    }
    setLoading(false);
  };

  const onDecline = async () => {
    const res = await declinePublicIntro({ introId: introId });
    if (res?.error?.length) {
      setIntroState(res?.error[0]);
      setLoading(false);
      return;
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    if (!introId?.length) {
      setIntroState('required_parmas_not_found');
      setLoading(false);
      return;
    }
    if (!(isDeny || isAccept)) {
      setIntroState('required_parmas_not_found');
      setLoading(false);
      return;
    }
    if (isFetching) return;
    if (
      isAccept &&
      publicIntro?.status === 'make_intro_request_permission' &&
      !isFetching
    ) {
      onAccept();
      return;
    }
    if (
      isDeny &&
      publicIntro?.status === 'make_intro_request_permission' &&
      !isFetching
    ) {
      onDecline();
      return;
    }
    setLoading(false);
  }, [publicIntro, isFetching]); // eslint-disable-line

  if (loading) {
    return (
      <Flex h="100vh" justifyContent="center" alignItems="center">
        <Spinner color="var(--kula-dark-primary-700, #0043CE)" />
      </Flex>
    );
  }

  if (introState) {
    return <IntroTextResult text={getMessage(introState)} />;
  }

  if (error?.length) {
    return <IntroTextResult text={getMessage(error[0])} />;
  }

  if (publicIntro?.status === 'make_intro_request_permission_rejected') {
    return <DeclinedIntro intro={publicIntro} introId={introId} />;
  }

  if (publicIntro?.status === 'make_intro_done') {
    return (
      <IntroTextResult
        text={getMessage('make_intro_done')}
        isIconPresent={true}
        icon={
          <Icon
            as={CheckCircle}
            width="55px"
            height="55px"
            mb="20px"
            color="#24A148"
          />
        }
      />
    );
  }

  if (publicIntro?.status === 'make_intro_fail') {
    return (
      <IntroTextResult
        text={getMessage('make_intro_fail')}
        isIconPresent={true}
        icon={
          <Icon
            as={CheckCircle}
            width="55px"
            height="55px"
            mb="20px"
            color="#24A148"
          />
        }
      />
    );
  }

  if (publicIntro?.status === 'make_intro_consent') {
    return (
      <IntroTextResult
        text={getMessage('make_intro_consent')}
        isIconPresent={true}
        icon={
          <Icon
            as={CheckCircle}
            width="55px"
            height="55px"
            mb="20px"
            color="#24A148"
          />
        }
      />
    );
  }

  return isAccept ? (
    <AccepetedIntro intro={publicIntro} />
  ) : (
    <IntroTextResult
      text={getMessage('intro_declined')}
      isIconPresent={true}
      icon={<Icon as={PublicDeny} width="161px" height="135px" mb="20px" />}
    />
  );
};
